import React from 'react'
import { LoaderCircle } from 'lucide-react'
import './pageLoading.css'
import { cn } from '@/lib/utils'


const PageLoading = ({ className }: { className?: string }) => {
  return (
    <div className={cn('loader flex items-center justify-center', className)}>
      <LoaderCircle className='text-muted-foreground h-6 w-6 animate-spin' />
    </div>
  )
}

export default PageLoading
